@if (editMode) {
<h2 mat-dialog-title>Edit user</h2>
} @else {
<h2 mat-dialog-title>Create new user</h2>
}

<form [formGroup]="form" (ngSubmit)="submit()" mat-dialog-content class="form-container">
    <div style="display: flex; flex-direction: column; padding: 10px; gap: 10px;">
        <mat-form-field appearance="outline">
            <mat-label>Username</mat-label>
            <input matInput type="text" formControlName="username" required />
            <mat-hint>Letters, numbers, -, _ only (min. 3)</mat-hint>
            <mat-error>Enter a valid username</mat-error>
        </mat-form-field>

        <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; gap: 10px;">
            <mat-form-field appearance="outline" style="width: 49%;">
                <mat-label>First name</mat-label>
                <input matInput type="text" formControlName="firstname" />
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 49%;">
                <mat-label>Last name</mat-label>
                <input matInput type="text" formControlName="lastname" />
            </mat-form-field>
        </div>

        <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput type="email" formControlName="email" required />
            <mat-hint>The email address is required: the login verification code is sent to it</mat-hint>
            <mat-error>Enter a valid email</mat-error>
        </mat-form-field>

        @if (!editMode) {
        <p style="margin: 0; color: rgba(0, 0, 0, 0.6);">The user will receive an email with a link to set
            their own password.</p>
        }

        <mat-form-field appearance="outline">
            <mat-label>Role</mat-label>
            <mat-select formControlName="roles" required>
                @for (option of roleOptions; track option) {
                <mat-option [value]="option">{{option.replace('ROLE_', '')}}</mat-option>
                }
            </mat-select>
            <mat-error>A role is required</mat-error>
        </mat-form-field>
    </div>

    <div mat-dialog-actions style="display: flex; flex-direction: row; justify-content: flex-end; gap: 10px;">
        <button mat-raised-button mat-dialog-close color="secondary" type="button">Cancel</button>
        <button mat-raised-button color="primary" type="submit">Save</button>
    </div>
</form>
